import ReactApexChart from "react-apexcharts";

const AppointmentBreakdownChart = ({ appointments }) => {
  const departmentCounts = appointments.reduce((acc, appointment) => {
    const department = appointment.doctor?.translations?.en?.department || "Other";
    acc[department] = (acc[department] || 0) + 1;
    return acc;
  }, {});

  const labels = Object.keys(departmentCounts);
  const series = Object.values(departmentCounts);

  const chartState = {
    series: series,
    options: {
      chart: {
        type: 'donut',
      },
      labels: labels,
      colors: ['#465DFF', '#6AC75A', '#67BAF1', '#F59E0B', '#EF4444', '#6B7280'],
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                label: 'Total Visits',
                fontSize: '18px',
                fontWeight: 600,
                color: '#373d3f',
              }
            }
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  };

  return (
    <div>
      <div id="chart" className="dashboard-donut-chart">
        <ReactApexChart
          options={chartState.options}
          series={chartState.series}
          type="donut"
          height={220}
        />
      </div>

      <div className="flex flex-col gap-y-3 mt-4">
        {labels.map((label, index) => (
          <div key={label} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-x-2">
              <span
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: chartState.options.colors[index % chartState.options.colors.length] }}
              ></span>
              <span className="text-gray-600">{label}</span>
            </div>
            <span className="font-semibold text-gray-800">
              {series[index]} {series[index] === 1 ? 'Visit' : 'Visits'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentBreakdownChart;